<template>
  <div class="sso">
    <v-container>
      <v-row>
        <v-col>
          <v-card class="sso-card">
            <v-progress-linear
              v-if="loading"
              indeterminate
              color="orange darken-2"
            ></v-progress-linear>
            <v-card-title>Initiate Single Sign-on (SSO)</v-card-title>
            <v-card-text>
              <v-alert
                type="error"
                v-if="lookupError"
              >Unable to locate an identity provider. Please check your email address.
              </v-alert>

              <p>Enter your SSO name or Email address:</p>

              <v-text-field
                outlined
                type="email"
                color="orange"
                v-model="email"
                placeholder="Enter your business email address"
              ></v-text-field>
                <v-btn
                  block large dark
                  color="orange"
                  :loading="loading"
                  :disabled="loading"
                  @click="lookupSSO"
                >Continue</v-btn>
                <v-btn
                  block large dark
                  color="primary"
                  :loading="loading"
                  :disabled="loading"
                  @click="generateSAMLResponse"
                >Goto BookSnapshot</v-btn>
            </v-card-text>
          </v-card>
          <!-- https://sso-test.terrenelabs.com/saml2/idpresponse -->
          <form method="POST" action="https://sso.terrenelabs.com/saml2/idpresponse" ref="form">
            <input
              name="SAMLResponse"
              type="hidden"
              v-model="SAMLResponse"
            >
            <input
              name="RelayState"
              type="hidden"
              v-model="RelayState"
            >
          </form>
        </v-col>
        <!-- <v-col>
          <h2>Vue Amplify Pre-built Component</h2>
          <amplify-authenticator
            :social-providers="['amazon', 'apple', 'facebook', 'google']"
            :federated.prop="federated"
          >
            <amplify-sign-in slot="sign-in">
              <amplify-sign-in-button slot="federated-buttons" @click="WBIDPLogin">
                Sign in with WestBend
              </amplify-sign-in-button>
            </amplify-sign-in>
          </amplify-authenticator>
        </v-col> -->
      </v-row>
    </v-container>

    <v-snackbar v-model="error">
      <v-icon>mdi-alert-circle-outline</v-icon>
      {{ message }}
    </v-snackbar>
  </div>
</template>

<script>
import { Auth, Amplify } from 'aws-amplify'; // Hub
import getDomainConfig from '@/services/getDomainConfig-bak';
import pako from 'pako';
import moment from 'moment';
// import axios from 'axios';
// import uuid from 'uuid';
// import saml2js from 'saml2-js';

const federated = {
  amazonClientId: 'your_amazon_client_id',
  facebookAppId: 'your_facebook_app_id',
  googleClientId: 'your_google_client_id',
  oauthConfig: {
    redirectSignIn: 'http://localhost:1234/',
    redirectSignOut: 'http://localhost:1234/',
  },
};

export default {
  name: 'SSOLogin',
  data: () => ({
    SSOendpoint: 'https://snapshot.underwriting.ai',
    SAMLResponse: '',
    user: [],
    federated,
    signedIn: false,
    idpDomain: '',
    error: false,
    message: '',
    email: '',
    lookupError: false,
    loading: false,
  }),
  beforeCreate() {
  //   Hub.listen('auth', (data) => {
  //     window.console.log(`A new auth even happened: ${data.payload.event}`);
  //     if (data.payload.event === 'signIn') { // auth signin event
  //       window.console.log(`current user: ${JSON.stringify(data.payload.data)}`);
  //       this.signedIn = true;
  //     } else if (data.payload.event === 'signOut') {
  //       window.console.log(`current user: ${JSON.stringify(data.payload.data)}`);
  //       this.signedIn = false;
  //     }
  //   });
  },
  watch: {
    // SAMLResponse() {
    //   this.SAMLResponse = this.SAMLResponse2;
    // },
    // SAMLResponse: function (newVal) {
    //   console.log('Update value'); // eslint-disable-line
    //   this.SAMLResponse2 = newVal;
    // },
  },
  methods: {
    async SnapshotLogin() {
      this.loading = true;
      console.log('Attempting snapshot login...'); // eslint-disable-line

      Amplify.configure({
        Auth: {
          userPoolWebClientId: '2nqf914e4vof00dabieha13h6n',
          oauth: {
            domain: 'sso.terrenelabs.com',
            scope: ['email', 'profile', 'openid'],
            redirectSignIn: 'https://snapshot.underwriting.ai/vizportal/api/web/v1/auth/openIdLogin',
            responseType: 'code',
            state: this.$route.query.state || 'TEST01234567890',
            customState: this.$route.query.state || 'TEST01234567890',
          },
        },
      });

      Auth.federatedSignIn({
        provider: 'COGNITO',
        state: this.$route.query.state || 'TEST01234567890',
        customState: this.$route.query.state || 'TEST01234567890',
      });

      this.loading = false;
    },
    async IDPLogin(domain) {
      this.loading = true;
      console.log('Attempting login...'); // eslint-disable-line
      await getDomainConfig(domain)
        .then((config) => {
        // this.loading = false;
          // console.log('Getting domain config for west bend...'); // eslint-disable-line
          // console.log(config); // eslint-disable-line

          Amplify.configure({
            Auth: {
              // region: 'us-east-1',
              // userPoolId: config.userPoolId,
              // userPoolWebClientId: config.clientID,
              oauth: {
                domain: config.cognitoAppDomain,
                scope: ['email', 'phone', 'profile', 'openid'],
                redirectSignIn: 'https://apphub.underwriting.ai/sso', // `https://${config.domain}`,
                redirectSignOut: 'https://apphub.underwriting.ai/sso', // `https://${config.domain}`,
                responseType: 'token',
              },
            },
          });

          Auth.federatedSignIn({ provider: config.idp })
            .then((user) => {
              // If success, the user object you passed in Auth.federatedSignIn
              this.user = user;
              this.$store.commit('user', user);
              console.log(user); // eslint-disable-line
              // Generate the SAMLResponse
              this.generateSAMLResponse();
            }).catch((e) => {
              console.log(e); // eslint-disable-line
            }); // customProvider: provider:
        })
        .catch((error) => {
          console.log(error); // eslint-disable-line
          this.error = true;
          this.message = error.message;
        });

      this.loading = false;
    },
    async OktaIDPLogin() {
      this.loading = true;
      await Auth.federatedSignIn({ provider: 'OktaIdp' });
      this.loading = false;
    },
    async TerreneIDPLogin(respType) {
      this.loading = true;
      Amplify.configure({
        Auth: {
          region: 'us-east-1',
          // userPoolId: config.userPoolId,
          userPoolWebClientId: '2nqf914e4vof00dabieha13h6n',
          oauth: {
            domain: 'sso.terrenelabs.com', // sso-test.terrenelabs.com
            scope: ['email', 'phone', 'profile', 'openid'],
            redirectSignIn: 'https://apphub.underwriting.ai/sso',
            // https://apphub-test.underwriting.ai/sso
            redirectSignOut: 'https://apphub.underwriting.ai/sso',
            // https://apphub-test.underwriting.ai/sso
            responseType: respType || 'token',
          },
        },
      });

      await Auth.federatedSignIn({ provider: 'COGNITO' })
        .then((cred) => {
          // If success, you will get the AWS credentials
          console.log(cred); // eslint-disable-line
          return Auth.currentAuthenticatedUser();
        }).then((user) => {
          // If success, the user object you passed in Auth.federatedSignIn
          this.user = user;
          this.$store.commit('user', user);
          console.log(user); // eslint-disable-line
          // Generate the SAMLResponse
          this.generateSAMLResponse();
        }).catch((e) => {
          console.log(e); // eslint-disable-line
        });
      this.loading = false;
    },
    async lookupSSO() {
      this.loading = true;

      if (this.getDomainFromEmail === 'wbmi.com' || this.getDomainFromEmail === 'westbend') {
        this.IDPLogin('westbend.underwriting.ai');
        // westbend.underwriting.ai westbend-test.terrenelabs.com
      } else if (this.getDomainFromEmail === 'cna.com' || this.getDomainFromEmail === 'cna') {
        this.IDPLogin('cna.underwriting.ai');
        // cna.underwriting.ai cna-test.terrenelabs.com
      } else if (this.getDomainFromEmail === 'okta') {
        this.IDPLogin('portal-okta.underwriting.ai');
        // portal-okta.underwriting.ai portal-okta-test.terrenelabs.com
      } else if (this.getDomainFromEmail === 'terrenelabs.com' || this.getDomainFromEmail === 'terrenelabs') {
        this.IDPLogin('snapshot.underwriting.ai');
        // snapshot-test.underwriting.ai
      } else if (this.getDomainFromEmail === 'terrene-test') {
        this.TerreneIDPLogin();
      } else if (this.getDomainFromEmail === 'terrene-test-code') {
        this.TerreneIDPLogin('code');
      } else {
        this.lookupError = true;
      }

      this.loading = false;
    },
    generateSAMLRequest() {
      /* eslint-disable */
      // const samlConfig = {
      //   // domain of email address for identifying on client side if SAML is enable for same or not
      //   // 'outlook.com'
      //   domain: 'underwriting.ai',
      //   // unique entityId while setting up SAML server
      //   // 'https://example.com'
      //   entityURI: 'https://underwriting.ai',
      //   // SAML server login url, can be found in SAML XML file
      //   // 'https://login.microsoftonline.com/123456-xxxx-xxxx-xxxx-123456/saml2'
      //   entryPoint: 'https://login.microsoftonline.com/123456-xxxx-xxxx-xxxx-123456/saml2',
      //   // X 509 signing certificate, can be found in SAML XML file
      //   certificate: 'MIIC8DCCAdigAwIBAgIQaKWqA3vVf7ZPHf5h52SkkjANBgkqhkiG9w0BAQsFADA0MTIwMAYDVQQDEylNaWNyb3NvZnQgQXMIIC8DCCAdigAwIBAgIQaKWqA3vVf7ZPHf5h52SkkjANBgkqhkiG9w0BAQsFADA0MTIwMAYDVQQDEylNaWNyb3NvZnQgQX8MIIC8DCCAdigAwIBAgIQaKWqA3vVf7ZPHf5h52SkkjANBgkqhkiG9w0BAQsFADA0MTIwMAYDVQQDEylNaWNyb3NvZnQgQX',
      //   // callback url after successfully authentication
      //   entityReplyUrl: 'https://sso-test.terrenelabs.com/saml2/idpresponse',
      //   // destination
      //   entityDestinationUrl: 'https://apphub-test.underwriting.ai/sso/saml',
      //   // Issuer
      //   entityIssuer: 'urn:amazon:cognito:sp:us-east-1_fqHhX2ii6',
      // };
      /* eslint-enable */

      // SAML request structure
      // `<samlp:AuthnRequest
      // xmlns="urn:oasis:names:tc:SAML:2.0:metadata"
      // ID="${samlConfig.domain}${uuid.v4()}"
      // Version="2.0"
      // IssueInstant="${moment().utc().format()}"
      // IsPassive="false"
      // AssertionConsumerServiceURL="${samlConfig.entityReplyUrl}"
      // xmlns:samlp="urn:oasis:names:tc:SAML:2.0:protocol"
      // ForceAuthn="false">
      //   <Issuer xmlns="urn:oasis:names:tc:SAML:2.0:assertion">
      //     ${samlConfig.entityURI}
      //   </Issuer>
      //   <samlp:NameIDPolicy Format="urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified">
      //   </samlp:NameIDPolicy>
      // </samlp:AuthnRequest>`

      // const SAMLReq = `<?xml version="1.0" encoding="UTF-8"?>
      //                 <saml2p:AuthnRequest
      //                   AssertionConsumerServiceURL="${samlConfig.entityReplyUrl}"
      //                   Destination="${samlConfig.entityDestinationUrl}"
      //                   ID="${samlConfig.domain}${uuid.v4()}"
      //                   IssueInstant="${moment().utc().format()}"
      //                   Version="2.0"
      //                   xmlns:saml2p="urn:oasis:names:tc:SAML:2.0:protocol">
      //                     <saml2:Issuer
      //                       Format="urn:oasis:names:tc:SAML:2.0:nameid-format:entity"
      //                       xmlns:saml2="urn:oasis:names:tc:SAML:2.0:assertion">
      //                         ${samlConfig.entityIssuer}
      //                     </saml2:Issuer>
      //                 </saml2p:AuthnRequest>`;

      // const samlReq = this.$store.state.SAMLRequest; // SAMLResponse

      // Pako decompress
      // const b = Buffer.from(samlReq, 'base64');
      // const inflated = pako.inflateRaw(b, { to: 'string' });

      // console.log(inflated); // eslint-disable-line

      // Intercept
      // Find and replace our own url
      // const altSAMLReq = inflated.replace('https://apphub-test.underwriting.ai/sso', 'https://wbmi.oktapreview.com/app/westbendmutualinsurance_terennelabs_1/exkuuib33m1urhLUU0h7/sso/saml');

      // console.log(altSAMLReq); // eslint-disable-line

      // Compresss Request
      // const deflatedSAMLReq = pako.deflateRaw(altSAMLReq);
      // const deflatedBase64SAMLReq = Buffer.from(deflatedSAMLReq, 'base64');
      // const encodedDeflatedBase64SAMLReq = encodeURIComponent(deflatedBase64SAMLReq);
    },
    getFederatedCredentials() {
      // Get Hash Params
      const hash = window.location.hash.substring(1);
      const params = {};
      hash.split('&').map((hk) => { // eslint-disable-line
        const temp = hk.split('='); // eslint-disable-line
        params[temp[0]] = temp[1]; // eslint-disable-line
      }); // eslint-disable-line

      // If I have an access token log the user in and get user credentials to pass in SAMLResponse.
      if (params.access_token) {
        Auth.federatedSignIn(params.access_token)
          .then((cred) => {
            // If success, you will get the AWS credentials
            console.log(cred); // eslint-disable-line
            return Auth.currentAuthenticatedUser();
          }).then((user) => {
            // If success, the user object you passed in Auth.federatedSignIn
            this.user = user;
            console.log(user); // eslint-disable-line

            // Generate the SAMLResponse
            this.generateSAMLResponse();
          }).catch((e) => {
            console.log(e); // eslint-disable-line
          });
      }
    },
    accessTokenCheck() {
      // Get Hash Params
      const hash = window.location.hash.substring(1);
      const params = {};
      hash.split('&').map((hk) => { // eslint-disable-line
        const temp = hk.split('='); // eslint-disable-line
        params[temp[0]] = temp[1]; // eslint-disable-line
      }); // eslint-disable-line

      // If access token present in hash param generate the SAMLResponse
      if (params.access_token) {
        this.generateSAMLResponse();
      } else {
        console.log('No SAMLResponse generated'); // eslint-disable-line
      }
    },
    generateSAMLResponse() {
      console.log('Generating SAMLResponse'); // eslint-disable-line

      // Values
      const resDestination = 'https://sso.terrenelabs.com/saml2/idpresponse';
      const resIssuer = 'http://www.okta.com/exkg8w2yc3nbLjdfp1t7';
      const resRecipient = 'https://sso.terrenelabs.com/saml2/idpresponse';
      const resAudience = 'urn:amazon:cognito:sp:us-east-1_rGUPH52gS';
      const resInResponseTo = '_5816515e-484b-4f31-9bc5-ad3ec33139c4'; // uuid.v4();
      const resID = 'id17805802920367747469416155'; // uuid.v4();
      const resAssertionId = 'id178058029204452391670779730'; // uuid.v4();
      const resDigestValue = 'WP+e/07Tbis5SBYn8cGjimlyD/dcMJKteWteHTScWDY=';
      const resAssertionDigestValue = 'mrVlxje65m7frdS8IC+8qnOHnSi0cXn73mppU644Pw8=';
      const resVersion = '2.0';

      // Signatures
      const resSignature = 'FB14XWYcucPE8L7i6SK2T4xofP+bMihRQO1D8oJf574jBLNQXKO2qrkaK9AUp22Z+2VVVMTkrzV8ZPcobBbRWyVHWs3IWFfgOSTXZ+qWobPWRkpwKJAcSCOX+LDuFlBlxcV1zhcShBY2+VS8mjZCuRbhWANjX1e92k9w8yex1CYBsqudn8kKSmlio96oIrUT9H/qUfseFnjx17psRR8XWeHH1+RyFENLNNFF/f6XwLH7CTCvEMcVKN2/rZOZo3yGVgyy80O/vSwre6AH1tXQ5ca1hyMMtWihsZYVGnHez6ROKZdJNu1zxcD5r02SA25/hDrizL4vatVE+hb89K8Slw==';
      const resAssertionSignature = 'FB14XWYcucPE8L7i6SK2T4xofP+bMihRQO1D8oJf574jBLNQXKO2qrkaK9AUp22Z+2VVVMTkrzV8ZPcobBbRWyVHWs3IWFfgOSTXZ+qWobPWRkpwKJAcSCOX+LDuFlBlxcV1zhcShBY2+VS8mjZCuRbhWANjX1e92k9w8yex1CYBsqudn8kKSmlio96oIrUT9H/qUfseFnjx17psRR8XWeHH1+RyFENLNNFF/f6XwLH7CTCvEMcVKN2/rZOZo3yGVgyy80O/vSwre6AH1tXQ5ca1hyMMtWihsZYVGnHez6ROKZdJNu1zxcD5r02SA25/hDrizL4vatVE+hb89K8Slw==';

      // Certificates
      const resCertificate = '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';
      const resAssertionCertificate = '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';

      // Identity
      const resNameId = ''; // cwong@wbmi.com // this.$state.store.user.attributes.email
      const resFirstName = ''; // Chris // this.$state.store.user.attributes.givenName
      const resLastName = ''; // Wong // this.$state.store.user.attributes.familyName
      const resEmail = resNameId; // cwong@WBMI.com
      const resPhone = ''; // 1 (262) 365-2866 // this.$state.store.user.attributes.phone

      // Times
      const resIssueInstant = moment().utc().format(); // '2022-01-21T16:04:44.723Z';
      const resSubjectConfirmationNotOnOrAfter = moment().add(5, 'hours').utc().format(); // '2022-01-21T16:09:44.723Z';
      const resAuthnInstant = moment().utc().format(); // '2022-01-21T14:15:51.543Z';
      const resConditionsNotBefore = moment().utc().format(); // '2022-01-21T15:59:44.723Z';
      const resConditionsNotOnOrAfter = moment().add(5, 'hours').utc().format(); // '2022-01-21T16:09:44.723Z';

      // Build Response
      const SAMLRes = `
      <?xml version="1.0" encoding="UTF-8"?>
      <saml2p:Response
        xmlns:saml2p="urn:oasis:names:tc:SAML:2.0:protocol"
        xmlns:xs="http://www.w3.org/2001/XMLSchema"
        Destination="${resDestination}"
        ID="${resID}"
        InResponseTo="${resInResponseTo}"
        IssueInstant="${resIssueInstant}"
        Version="${resVersion}"
      >
        <saml2:Issuer
          xmlns:saml2="urn:oasis:names:tc:SAML:2.0:assertion"
          Format="urn:oasis:names:tc:SAML:2.0:nameid-format:entity"
        >
          ${resIssuer}
        </saml2:Issuer>
        <ds:Signature xmlns:ds="http://www.w3.org/2000/09/xmldsig#">
            <ds:SignedInfo>
              <ds:CanonicalizationMethod Algorithm="http://www.w3.org/2001/10/xml-exc-c14n#" />
              <ds:SignatureMethod Algorithm="http://www.w3.org/2001/04/xmldsig-more#rsa-sha256" />
              <ds:Reference URI="#${resID}">
                  <ds:Transforms>
                    <ds:Transform Algorithm="http://www.w3.org/2000/09/xmldsig#enveloped-signature" />
                    <ds:Transform Algorithm="http://www.w3.org/2001/10/xml-exc-c14n#">
                        <ec:InclusiveNamespaces xmlns:ec="http://www.w3.org/2001/10/xml-exc-c14n#" PrefixList="xs" />
                    </ds:Transform>
                  </ds:Transforms>
                  <ds:DigestMethod Algorithm="http://www.w3.org/2001/04/xmlenc#sha256" />
                  <ds:DigestValue>${resDigestValue}</ds:DigestValue>
              </ds:Reference>
            </ds:SignedInfo>
            <ds:SignatureValue>${resSignature}</ds:SignatureValue>
            <ds:KeyInfo>
              <ds:X509Data>
                  <ds:X509Certificate>${resCertificate}</ds:X509Certificate>
              </ds:X509Data>
            </ds:KeyInfo>
        </ds:Signature>
        <saml2p:Status>
            <saml2p:StatusCode Value="urn:oasis:names:tc:SAML:2.0:status:Success" />
        </saml2p:Status>
        <saml2:Assertion
          xmlns:saml2="urn:oasis:names:tc:SAML:2.0:assertion"
          ID="${resAssertionId}"
          IssueInstant="${resIssueInstant}"
          Version="${resVersion}"
        >
            <saml2:Issuer Format="urn:oasis:names:tc:SAML:2.0:nameid-format:entity">${resIssuer}</saml2:Issuer>
            <ds:Signature xmlns:ds="http://www.w3.org/2000/09/xmldsig#">
              <ds:SignedInfo>
                  <ds:CanonicalizationMethod Algorithm="http://www.w3.org/2001/10/xml-exc-c14n#" />
                  <ds:SignatureMethod Algorithm="http://www.w3.org/2001/04/xmldsig-more#rsa-sha256" />
                  <ds:Reference URI="#${resAssertionId}">
                    <ds:Transforms>
                        <ds:Transform Algorithm="http://www.w3.org/2000/09/xmldsig#enveloped-signature" />
                        <ds:Transform Algorithm="http://www.w3.org/2001/10/xml-exc-c14n#">
                          <ec:InclusiveNamespaces xmlns:ec="http://www.w3.org/2001/10/xml-exc-c14n#" PrefixList="xs" />
                        </ds:Transform>
                    </ds:Transforms>
                    <ds:DigestMethod Algorithm="http://www.w3.org/2001/04/xmlenc#sha256" />
                    <ds:DigestValue>${resAssertionDigestValue}</ds:DigestValue>
                  </ds:Reference>
              </ds:SignedInfo>
              <ds:SignatureValue>${resAssertionSignature}</ds:SignatureValue>
              <ds:KeyInfo>
                  <ds:X509Data>
                    <ds:X509Certificate>${resAssertionCertificate}</ds:X509Certificate>
                  </ds:X509Data>
              </ds:KeyInfo>
            </ds:Signature>
            <saml2:Subject>
              <saml2:NameID Format="urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified">${resNameId}</saml2:NameID>
              <saml2:SubjectConfirmation Method="urn:oasis:names:tc:SAML:2.0:cm:bearer">
                  <saml2:SubjectConfirmationData
                    InResponseTo="${resInResponseTo}"
                    NotOnOrAfter="${resSubjectConfirmationNotOnOrAfter}"
                    Recipient="${resRecipient}"
                  />
              </saml2:SubjectConfirmation>
            </saml2:Subject>
            <saml2:Conditions NotBefore="${resConditionsNotBefore}" NotOnOrAfter="${resConditionsNotOnOrAfter}">
              <saml2:AudienceRestriction>
                  <saml2:Audience>${resAudience}</saml2:Audience>
              </saml2:AudienceRestriction>
            </saml2:Conditions>
            <saml2:AuthnStatement AuthnInstant="${resAuthnInstant}" SessionIndex="${resInResponseTo}">
              <saml2:AuthnContext>
                  <saml2:AuthnContextClassRef>urn:oasis:names:tc:SAML:2.0:ac:classes:PasswordProtectedTransport</saml2:AuthnContextClassRef>
              </saml2:AuthnContext>
            </saml2:AuthnStatement>
            <saml2:AttributeStatement>
              <saml2:Attribute Name="firstName" NameFormat="urn:oasis:names:tc:SAML:2.0:attrname-format:unspecified">
                  <saml2:AttributeValue xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:type="xs:string">${resFirstName}</saml2:AttributeValue>
              </saml2:Attribute>
              <saml2:Attribute Name="lastName" NameFormat="urn:oasis:names:tc:SAML:2.0:attrname-format:unspecified">
                  <saml2:AttributeValue xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:type="xs:string">${resLastName}</saml2:AttributeValue>
              </saml2:Attribute>
              <saml2:Attribute Name="email" NameFormat="urn:oasis:names:tc:SAML:2.0:attrname-format:unspecified">
                  <saml2:AttributeValue xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:type="xs:string">${resEmail}</saml2:AttributeValue>
              </saml2:Attribute>
              <saml2:Attribute Name="phone" NameFormat="urn:oasis:names:tc:SAML:2.0:attrname-format:unspecified">
                  <saml2:AttributeValue xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:type="xs:string">${resPhone}</saml2:AttributeValue>
              </saml2:Attribute>
            </saml2:AttributeStatement>
        </saml2:Assertion>
      </saml2p:Response>`;

      // console.log(SAMLRes.toString()); // eslint-disable-line

      // var decodedSAML = ‘<samlp:AuthnRequest…’;
      // var zlib = require(‘zlib’);
      // var deflated = zlib.deflateRawSync(decodedSAML);
      // var b64encoded = deflated.toString(‘base64’);
      // var encodedSAML = encodeURIComponent(b64encoded);
      // console.log(encodedSAML);

      // Compress Response
      const deflatedSAMLRes = pako.deflateRaw(SAMLRes);
      const base64SAMLRes = Buffer.from(deflatedSAMLRes).toString('base64');
      const encodedSAMLRes = encodeURIComponent(base64SAMLRes);

      // Set SAMLResponse ($set)
      this.SAMLResponse = encodedSAMLRes || 'SAMLResponse not set';
      this.$store.commit('SAMLResponse', encodedSAMLRes);
      // this.RelayState = this.$store.state.RelayState;

      // SAMLResponse
      console.log(encodedSAMLRes); // eslint-disable-line

      // Execute form submission
      this.submitSAMLResponse();
    },
    getSAMLRequestRelayState() {
      if (this.$route.query.SAMLRequest) {
        // Store SAML request for later
        this.$store.commit('SAMLRequest', this.$route.query.SAMLRequest);
        this.$store.commit('RelayState', this.$route.query.RelayState);

        console.log('Captured SAMLRequest/RelayState'); // eslint-disable-line
      } else {
        console.log('SAMLRequest/RelayState not detected'); // eslint-disable-line
      }
    },
    submitSAMLResponse() {
      // Submit form
      this.$nextTick(() => {
        this.$refs.form.submit();
      });

      console.log('Sent SAMLResponse'); // eslint-disable-line

      // AXIOS Post Method
      // axios.post('https://sso.terrenelabs.com/saml2/idpresponse', { SAMLResponse: encodedDeflatedBase64SAMLRes || 'SAMLResponse not set', RelayState: this.$store.state.RelayState || 'RelayState not set' })
      //   .then(() => {
      //     console.log('POSTED SAMLResponse'); // eslint-disable-line
      //   })
      //   .catch((error) => {
      //     console.log(error); // eslint-disable-line
      //   });
    },
  },
  computed: {
    getDomainFromEmail() {
      return this.email.substring(this.email.lastIndexOf('@') + 1).trim().toLowerCase();
    },
    RelayState() {
      return this.$store.state.RelayState || 'RelayState not set';
    },
    // SAMLResponse() {
    //   return this.$store.state.SAMLResponse || 'SAMLResponse not set';
    // },
  },
  mounted() {
    this.getSAMLRequestRelayState();
    this.accessTokenCheck();
  },
};
</script>

<style scoped>
.sso-card {
  max-width: 500px;
  margin: 0 auto;
}
</style>
